import { NgModule, Component, OnInit, OnDestroy, Input, ElementRef, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SocketService } from '../../services/socket.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HttpService } from '../../services/http.service';
import { ToasterService } from '../../services/toaster.service';
import { SharedPipeChatModule } from '../../shared/shared.pipe.chat.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
@Component({
    selector: 'chat-room-basic',
    template: `
    <!-- chat_box -->
    <div class="chat_box">
        <!-- 공지-->
        <div #scrollMe class="chat_list scroll" [ngStyle]="{height: (dynamicHeight) + 'px'}" >
            <div *ngFor="let message of messages" [innerHTML]="message"></div>
        </div>
        <div class="chat-input">
            <div class="input">
                <mat-form-field class="w100p" floatLabel="never">
                    <input matInput class="w100p" [(ngModel)]="data.message" name="message" placeholder="이곳에 메시지를 입력해주세요." required>
                </mat-form-field>
            </div>
            <button mat-button aria-label="전체채팅" class="mat-mat-button mat-button" (click)="sendMessage();">전송</button>
        </div>
    </div>
    <!-- // chat_box -->
`
})

export class ChatBasicComponent implements OnInit, OnDestroy {
    private ngUnsubscribe = new Subject();
    // showNum = 0;
    messages = []; // 채팅 내용;
    data: any = {message: ''};
    dynamicHeight = 300;
    sockConnection = new Array();


    // @ViewChild('scrollMe') private myScrollContainer: ElementRef;
    @ViewChild('scrollMe', {static: true}) myScrollContainer: ElementRef;

    @Input() set resizeObject(resizeData: {edges: any, rectangle: any }) {
        if (!resizeData.rectangle) {
            return;
        }
        const rectangleHeight = resizeData.rectangle.height - 78;
        this.dynamicHeight = rectangleHeight;
    }

    @Input() set selectedChatIndex(index: number) {
        // this.socketService.removeListener('chatTabs');
        if (index === 0) {
            this.socketService.removeListener('chanceTalkView'); // 찬스톡 상세보기 관련 리스너 삭제
            this.socketService.leaveRoom('@basic1'); // 찬스톡에 의해 세팅된 각각의 방을 떠난다.
            // this.socketService.Emit('leave_curent_room', '@basic1');
            // 공개 채팅방이면
            this.init();
        }
    }

    constructor(
        private socketService: SocketService,
        private http: HttpService,
        private toasterService: ToasterService
    ) {}

    ngOnInit() {
        // console.log('ngOnInit');
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    private init() {
        this.scrollToBottom();
        this.socketService.Emit('add_page', {page: '@basic1'});
        this.socketService.Emit('refreshChatHistory', {chatRoom : '@basic1'});

        // 채팅 내용 히스토리 받기 시작
        this.socketService.sockConnection.publicChat.push(
            this.socketService.On('chatList')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(obj => {
                const myData: any = obj[0].reverse();
                for (const data of myData) {
                    this.messages.push(this.message_template(JSON.parse(data)));
                }

                this.scrollToBottom();
            })
        );

        // 실시간 채팅 내역 받기
        this.socketService.sockConnection.publicChat.push(
            this.socketService.On('receiveMessage')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(obj => {
                this.messages.push(this.message_template(obj[0]));
                this.scrollToBottom();

            })
        );
    }

    private message_template(req: any) {
        let chatList = '';
        let userDisplayPick: string;
        switch (req.msgType) {
            case 'pickRegis': // 픽등록
                chatList += '<p class="chatNotice pickreg">' + req.msg + '</p>';
                break;
            case 'pickResult': // 픽결과발표
            /*
                let result_class = '';
                result_class    = req.detail.pick;
                switch (req.detail.pick) {
                    case 'ladder':
                        switch (req.detail.ladder_result) {
                            case '1':
                                result_class = 'blue';
                                break;
                            case '2':
                                result_class = 'red';
                                break;
                        }
                        break;
                }
                chatList += '<p class="chatNotice pickresult ' + result_class + '">' + req.msg + '</p>';
                */
                break;
            case 'mem_regis': // 회원가입알림
                chatList += '<p class="chatNotice auto">' + req.msg + '</p>';
                break;
            case 'room_created': // 채팅방 개설 // req.data.roomid+
                chatList += '<p class="chatNotice auto">' + req.msg + '</p>';
                break;
            case 'admin_alert': //
                chatList += '<p class="chatNotice alert">' + req.msg + '</p>';
                break;
            case 'admin_jail': //
                chatList += '<p class="chatNotice jail">' + req.msg + '</p>';
                break;
            case 'admin_prohibit': //
                chatList += '<p class="chatNotice prohibit">' + req.msg + '</p>';
                break;
            case 'admin_notice': //
                chatList += '<p class="chatNotice auto">' + req.msg + '</p>';
                break;
            default: //
                if (req.user.mb_lv === '100' || req.user.mb_lv === '99') { // 관리자와 메니저일경우 승률 디스플레이금지, 레이어창 비활성화
                    chatList += '<p><span><img src="assets/images/common/lv/' + req.user.mb_lv + '.png" alt="" class="lvS1">';
                    chatList += req.user.mb_nick;
                    chatList += '</span>';
                    chatList += '<em>' + req.msg + '</em></p>';

                } else {

                    let winloseinfo = {win: 0, lose: 0, series_win: 0, series_lose: 0};
                    if (typeof (req.other) !== 'undefined') {
                        if (typeof (req.other) === 'string') {
                            req.other = JSON.parse(req.other);
                        }

                        if (req.chatRoom === '@basic1') {
                            if (req.other.powerLadder) {
                                userDisplayPick = 'powerLadder';
                                winloseinfo = req.other.powerLadder;
                            } else if (req.other.powerball) {
                                userDisplayPick = 'powerball';
                                winloseinfo = req.other.powerball;
                            } else if (req.other.dari) {
                                userDisplayPick = 'dari';
                                winloseinfo = req.other.dari;
                            } else if (req.other.ladder) {
                                userDisplayPick = 'ladder';
                                winloseinfo = req.other.ladder;
                            }
                        }
                    }

                    let winlosestr = '';
                    if (winloseinfo.win !== 0 || winloseinfo.lose !== 0) {
                        winlosestr = '(';
                        winlosestr += winloseinfo.win + '승' + winloseinfo.lose + '패';
                        if (winloseinfo.series_win !== 0) {
                            winlosestr += '<span class="col_red">' + winloseinfo.series_win + '연승중</span>';
                        } else if (winloseinfo.series_lose !== 0) {
                            winlosestr += '<span class="col_blue">' + winloseinfo.series_lose + '연패중</span>';
                        }
                        winlosestr += ')';
                    }

                    chatList += '<p><span><img src="assets/images/common/lv/' + req.user.mb_lv + '.png" alt="" class="lvS1">';
                    chatList += req.user.mb_nick;
                    if (typeof (userDisplayPick) !== 'undefined') {
                        chatList += '<i class="gameicon s12 ' + userDisplayPick + '"></i> ';
                    }
                    chatList += winlosestr + '</span>';
                    chatList += '<em>' + req.msg + '</em></p>';
                }
                break;
        } // switch (req.msgType) {
        return chatList;
    }


    sendMessage() {
        // const data = {};
        const message = this.data.message;
        if (message === '') {
            return;
        }

        this.http.get({url: 'mypage/chat_prohibit_status'}).then((obj) => {
            if (obj.result === false) {
                this.toasterService.showToaster('error', obj.message);
            } else {
                 // 현재 사용자의 연승 연패 정보를 구한다. (현재는 left에서만 디스플레이)
                // this.http.get({url: 'pick/get_winloseinfo', params: {pick: 'ladder'}}).then((res) => {
                this.http.get({url: 'pick/get_winloseinfo', params: {}}).then((res) => {
                    this.socketService.Emit('setMessage', {chatRoom: '@basic1', msg : message, other: res, room_type: 'public'});
                });

            }
        });
        delete this.data.message;
    }

    private scrollToBottom(): void {
        setTimeout(() => {
            try {
                this.myScrollContainer.nativeElement.scrollTop = (this.myScrollContainer.nativeElement.scrollHeight + 120);
            } catch (err) { }
        }, 200);
    }
}

@NgModule({
    declarations: [ ChatBasicComponent ],
    imports: [ CommonModule, FormsModule, MatFormFieldModule, MatInputModule , SharedPipeChatModule],
    exports: [ChatBasicComponent]
})
export class ChatBasicModule {}
